import request from '@/utils/request'

export function getSystemLogs(query) {
  return request({
    url: '/logs/list',
    method: 'get',
    params: query
  })
}

export function addSystemLog(data) {
  return request({
    url: '/logs/add',
    method: 'post',
    data
  })
}

export function delSystemLogs(ids) {
  return request({
    url: '/logs/del',
    method: 'post',
    data: { ids }
  })
}
